if(typeof BSS_B2B != undefined) {
  if(window.location.pathname === "/pages/b2b-signup") {
    setTimeout(() =>{
      $("#MainContent .form-group:not(.field-country-field, .field-accepts-marketing)"
      ).each(function (ind, item) {
        $(item).addClass("field");
        const input = $(item).find("input");
        const label = $(item).find("label");
        if (input) {
          $("input").attr("placeholder", " ");
        }
        if (input && label) {
          input.after(label);
        }
      });
    }, 200)
    
  }
}